import officeApi from '../../api/officeApi';

export const isDesktop = () => {
  return ['PC', 'Mac'].includes(officeApi.getPlatform());
};

export const isPC = () => {
  return officeApi.getPlatform() === 'PC';
};
